import { createAction } from 'redux-actions'

const ns = 'login/'

export const doLogin = createAction(`${ns}DO_LOGIN`)
export const setLoginInProgress = createAction(`${ns}SET_LOGIN_IN_PROGRESS`)

// SSO: email-first login flow actions
export const checkLoginMethod = createAction(`${ns}CHECK_LOGIN_METHOD`)
export const checkLoginMethodSuccess = createAction(`${ns}CHECK_LOGIN_METHOD_SUCCESS`)
export const checkLoginMethodFail = createAction(`${ns}CHECK_LOGIN_METHOD_FAIL`)
// Reset the login step back to email entry
export const resetLoginStep = createAction(`${ns}RESET_LOGIN_STEP`)
// SSO callback: exchange sessionId and complete login
export const completeSsoLogin = createAction(`${ns}COMPLETE_SSO_LOGIN`)
